import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
import { computed } from "vue";
const apiKey = "AIzaSyBZlJlLPBHmdWpaje4oCiav5M9ngQ36CMg";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UMap',
    props: {
        address: {}
    },
    setup(__props) {
        const props = __props;
        const url = computed(() => {
            const adr = encodeURI(props.address);
            return `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${adr}`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("iframe", {
                src: url.value,
                width: "100%",
                height: "384",
                style: { "border": "0", "border-radius": "20px" },
                loading: "lazy",
                referrerpolicy: "no-referrer-when-downgrade"
            }, null, 8, _hoisted_1));
        };
    }
});
